import { IReduxStateData } from "../interfaces/redux";
import { getToken } from "./getLocalStorageData";
var GetActiveLcdData = function (globalState: IReduxStateData) {
    const token = getToken();
    if (token && token.length && globalState.activeLcdIndex !== -1 && globalState.activeLcdAlphaIdentifier && globalState.lcdData.length && globalState.lcdData[globalState.activeLcdIndex].alphacode_identifier === globalState.activeLcdAlphaIdentifier) {
        return globalState.lcdData[globalState.activeLcdIndex];
    }
}
export default GetActiveLcdData;
